import React from 'react';
import { TextAreaFieldItem, TextFieldItem } from 'ui-lib';
import { IComponentVersionWizardComponent } from '../component-version-wizard.types';

interface IGeneralStepProps {
    component: IComponentVersionWizardComponent;
    versionDisabled: boolean;
    versionValidator: (version?: string) => string | null;
}

export const GeneralStep = (props: IGeneralStepProps): JSX.Element => {
    return (
        <React.Fragment>
            <TextFieldItem
                labelAlign='right'
                code='componentName'
                label='Name'
                disabled={true}
                initialValue={props.component.displayName || ''}
            />
            <TextFieldItem
                labelAlign='right'
                code='componentType'
                label='Type'
                disabled={true}
                initialValue={props.component.type || ''}
            />
            <TextFieldItem
                labelAlign='right'
                code='version'
                label='Version'
                isRequired={true}
                disabled={props.versionDisabled}
                validator={(_, value, callback): void => {
                    if (props.versionDisabled) {
                        return callback(undefined);
                    }
                    const errorMessage = props.versionValidator(value);
                    callback(errorMessage || undefined);
                }}
            />
            <TextAreaFieldItem
                labelAlign='right'
                code='description'
                label='Description'
                textAreaProps={{ autoSize: { minRows: 4, maxRows: 6 } }}
            />
        </React.Fragment>
    );
};
